var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material/Icons/\uB0B4\uC5ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material/Icons/\\uB0B4\\uC5ED",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u110C\\u1161\\u1109\\u1161\\u11AB-42",
    transform: "translate(3.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "12.5295534 0 0 0 0 24 17.9534635 24 17.9534635 5.42391014"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBEFF2",
    points: "12.093073 1.47633057 1.10403851 1.47633057 1.10403851 22.5236694 16.849425 22.5236694 16.849425 6.23910136"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "11.0147098 1.47633057 11.0147098 7.27895159 16.8558438 7.27895159 16.8558438 6.23910136 12.093073 1.47633057"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D5D6DB",
    points: "12.6900241 2.05402514 12.6900241 5.65498796 16.2909869 5.65498796"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D5D6DB",
    x: 4.58304359,
    y: 9.84648302,
    width: 8.80021396,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D5D6DB",
    x: 4.58304359,
    y: 12.394758,
    width: 8.80021396,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D5D6DB",
    x: 4.58304359,
    y: 14.9494517,
    width: 8.80021396,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D5D6DB",
    x: 4.58304359,
    y: 17.5041455,
    width: 8.80021396,
    height: 1,
    rx: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHistory);
export default __webpack_public_path__ + "static/media/menu_history.5846422ef8d16ebcdf3ffcf8f9b5ee14.svg";
export { ForwardRef as ReactComponent };